import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketCreation = io(`${socketBaseUrl}/creation-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketCreation;
